
import { Component, Emit } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { email, maxLength, required } from 'vuelidate/lib/validators';
import { emailLocalPartMaxLength } from '@/mixins/validations/email-validation';
import { LoginFormData } from '@/model/Authentication';
import { mixins } from 'vue-class-component';
import FormValidationMixin from '@/mixins/FormValidationMixin';
import FormInput from '@/components/form/FormInput.vue';
import ResetPasswordRequest from '@/active-components/reset-password/ResetPasswordRequest.vue';

@Component({
    components: {
        FormInput,
        ResetPasswordRequest,
    },
})
export default class LoginForm extends mixins(FormValidationMixin) {
    formData = {
        email: '',
        password: '',
    } as LoginFormData;

    submitted = false;

    @Validations()
    validations = {
        formData: {
            email: {
                email,
                required,
                maxLength: maxLength(80),
                localPartMaxLength: (value: string): boolean =>
                    emailLocalPartMaxLength(value),
            },
            password: { required },
        },
    };

    @Emit()
    submit(): LoginFormData {
        return this.formData;
    }

    onSubmit(): void {
        this.submitted = true;

        this.$v.formData.$touch();
        if (!this.$v.$invalid) {
            this.submit();
        }
    }
}
